import React from 'react'

export default function HelpPage({ hasPermission, canAccessBilling, isManager }) {

    const showLogistics = isManager || hasPermission('logistics');
    const showRoutes = isManager || hasPermission('routes');
    const showBilling = isManager || canAccessBilling;
    const showUsers = isManager || hasPermission('users:manager');

    function Check() {
        return <i className="fa-solid fa-circle-check text-success" />;
    }

    function Cross() {
        return <i className="fa-solid fa-circle-xmark text-danger" />;
    }

    return (
        <div className="card mb-4">
            <div className="card-header py-3">
                <div className="row py-3">
                    <div className="col-sm-4 text-center text-sm-start">
                        <h5 className="mb-4 mb-sm-0 mt-2">
                            Aide
                        </h5>
                    </div>
                </div>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-8">
                        {showLogistics && <section id="logistics">
                            <h3>Logistique</h3>
                            <div className="alert alert-info mt-3">
                                <i className="fas fa-info-circle me-2"></i>
                                Permission requise : <span className="badge badge-primary">Logistique</span>
                            </div>
                            <p>Le module logistique permet de rechercher des conteneurs et de générer des documents PDF pour les opérations quotidiennes.</p>
                            <h5>Recherche de conteneur</h5>
                            <p>Cliquez sur <strong>Rechercher</strong> pour ouvrir la fenêtre de recherche :</p>
                            <ul>
                                <li><strong>Date :</strong> sélectionnez la date de l'opération</li>
                                <li><strong>Type :</strong> choisissez entre Sac et Cage</li>
                                <li><strong>Conteneur :</strong> saisissez un ou plusieurs codes de conteneurs (un par ligne). Vous pouvez rechercher jusqu'à 500 conteneurs en une seule requête.</li>
                            </ul>
                            <h5>Résultats</h5>
                            <p>Le tableau affiche pour chaque conteneur :</p>
                            <ul>
                                <li>code du conteneur</li>
                                <li>code du hub de destination</li>
                                <li>consigne ou commerce</li>
                                <li>point de livraison et nom du commerce</li>
                                <li>adresse complète du point</li>
                                <li>numéro de la route et position dans la séquence</li>
                            </ul>
                            <p>Utilisez la barre de recherche pour filtrer les résultats par nom, code conteneur, code point ou code cage.</p>
                            <h5>Documents PDF</h5>
                            <p>Après une recherche, deux boutons apparaissent :</p>
                            <ul>
                                <li><strong>Télécharger :</strong> génère les étiquettes d'expédition pour les conteneurs trouvés.</li>
                                <li><strong>Rapport :</strong> génère un rapport de routes regroupant les conteneurs par destination.</li>
                            </ul>
                        </section>}
                        {showRoutes && <>{showLogistics && <hr />}<section id="routes">
                            <h3>Route</h3>
                            <div className="alert alert-info mt-3">
                                <i className="fas fa-info-circle me-2"></i>
                                Permission requise : <span className="badge badge-primary">Route</span>
                            </div>
                            <p>Le module routes permet le suivi en temps réel des livraisons avec une carte interactive.</p>
                            <h5>Vue d'ensemble</h5>
                            <p>La page principale affiche toutes les routes du jour sélectionné :</p>
                            <ul>
                                <li>Utilisez les flèches ou le sélecteur de date pour naviguer entre les jours</li>
                                <li>Chaque carte de route montre le <strong>numéro de la route</strong>, le <strong>livreur</strong>, et une <strong>barre de progression</strong></li>
                                <li>Les routes en cours sont animées et les positions des livreurs sont affichées sur la carte</li>
                            </ul>
                            <h5>Barre de progression</h5>
                            <p>Les compteurs de dépôts et collectes sont affichés sous la barre de progression.</p>

                            <h5>Détail d'une route</h5>
                            <p>Cliquez sur une route pour voir le détail complet :</p>
                            <ul>
                                <li><strong>Liste des arrêts :</strong> chaque point de visite avec son statut, adresse et horaires</li>
                                <li><strong>Horaires :</strong> heure d'arrivée et de départ estimées et constatées si disponible</li>
                                <li><strong>Problèmes :</strong> les problèmes signalés (consigne pleine, colis trop volumineux, compartiment bloqué, magasin fermé) avec photos</li>
                            </ul>

                            <h5>Options de la carte</h5>
                            <ul>
                                <li><strong>Trajet estimé :</strong> affiche le trajet prévu</li>
                                <li><strong>Trajet réel :</strong> affiche le trajet effectivement parcouru par le livreur</li>
                            </ul>
                        </section></>}
                        {showBilling && <>{(showLogistics || showRoutes) && <hr />}<section id="billings">
                            <h3>Facturation</h3>
                            <div className="alert alert-info mt-3">
                                <i className="fas fa-info-circle me-2"></i>
                                Permission requise : <span className="badge badge-primary">Consultation des factures</span> <span className="badge badge-primary">Gestion des identifiants</span>
                            </div>
                            <p>Le module facturation permet de consulter l'historique de vos factures et de lier vos identifiants Vinted.</p>
                            <h5>Liste des factures</h5>
                            <p>Le tableau affiche pour chaque facture :</p>
                            <ul>
                                <li><strong>Numéro :</strong> référence unique de la facture</li>
                                <li><strong>Statut :</strong> état actuel de la facture</li>
                                <li><strong>Abonnement :</strong> plan associé</li>
                                <li><strong>Date d'émission :</strong> date d'émission de la facture</li>
                                <li><strong>Date d'échéance :</strong> date limite de paiement</li>
                                <li><strong>Date de paiement :</strong> date effective du paiement</li>
                            </ul>
                            <h5>Liaison des identifiants</h5>
                            <p>Cliquez sur <strong>Lier</strong> pour associer votre compte Vinted. Ces identifiants permettent à Nemo d'accéder aux données de conteneurs et de routes.</p>
                            <ul>
                                <li>Si un compte est déjà lié, son adresse e-mail est affichée</li>
                                <li>Vous pouvez mettre à jour les identifiants à tout moment</li>
                            </ul>
                        </section></>}
                        {showUsers && <>{(showLogistics || showRoutes || showBilling) && <hr />}<section id="users">
                            <h3>Utilisateurs</h3>
                            <div className="alert alert-info mt-3">
                                <i className="fas fa-info-circle me-2"></i>
                                Permission requise : <span className="badge badge-primary">Gestion des utilisateurs</span>
                            </div>
                            <p>Ce module permet de gérer les membres de votre équipe et de contrôler leurs accès.</p>
                            <h5>Liste des utilisateurs</h5>
                            <p>Le tableau affiche tous les utilisateurs de votre entreprise avec :</p>
                            <ul>
                                <li><strong>Nom :</strong> prénom et nom de l'utilisateur</li>
                                <li><strong>Email :</strong> adresse e-mail de connexion</li>
                                <li><strong>Rôle :</strong> rôle entre manager ou employé</li>
                                <li><strong>Statut :</strong> actif ou supprimé</li>
                            </ul>
                            <p>Cliquez sur un utilisateur pour voir son détail et gérer ses permissions.</p>
                            <table className="table table-hover align-middle mb-4 bg-white text-center">
                                <thead className="bg-light">
                                    <tr>
                                        <th>Rôle</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><span className="badge badge-success">Manager</span></td>
                                        <td className="text-start">Accès complet à toutes les fonctionnalités. Peut gérer les utilisateurs et les invitations de son entreprise</td>
                                    </tr>
                                    <tr>
                                        <td><span className="badge badge-secondary">Employé</span></td>
                                        <td className="text-start">Accès restreint selon les permissions attribuées. Ne peut pas gérer les autres utilisateurs sans permission explicite</td>
                                    </tr>
                                </tbody>
                            </table>
                            <h5>Permissions</h5>
                            <p>Les permissions contrôlent l'accès aux différents modules pour les employés :</p>
                            <table className="table table-hover align-middle mb-4 bg-white text-center">
                                <thead className="bg-light">
                                    <tr>
                                        <th>Permission</th>
                                        <th>Accès</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><span className="badge badge-primary">Logistique</span></td>
                                        <td className="text-start">Recherche de conteneurs, génération d'étiquettes et rapports PDF</td>
                                    </tr>
                                    <tr>
                                        <td><span className="badge badge-primary">Route</span></td>
                                        <td className="text-start">Suivi des routes en temps réel, détails des arrêts, planification</td>
                                    </tr>
                                    <tr>
                                        <td><span className="badge badge-primary">Gestion des utilisateurs</span></td>
                                        <td className="text-start">Voir, inviter et supprimer des utilisateurs</td>
                                    </tr>
                                    <tr>
                                        <td><span className="badge badge-primary">Consultation des factures</span></td>
                                        <td className="text-start">Consulter l'historique de facturation</td>
                                    </tr>
                                    <tr>
                                        <td><span className="badge badge-primary">Gestion des identifiants</span></td>
                                        <td className="text-start">Lier et modifier les identifiants</td>
                                    </tr>
                                </tbody>
                            </table>
                            <h5>Invitations</h5>
                            <p>Cliquez sur <strong>Inviter</strong> pour ajouter un nouvel utilisateur. Renseignez le prénom, nom, e-mail et les permissions souhaitées. L'utilisateur recevra un e-mail avec un lien pour définir son mot de passe et activer son compte.</p>
                            <ul>
                                <li>Les invitations en attente sont visibles dans la section dédiée</li>
                                <li>Vous pouvez annuler une invitation avant qu'elle ne soit acceptée</li>
                            </ul>
                            <h5>Suppression et restauration</h5>
                            <p>La suppression d'un utilisateur est <strong>réversible</strong>.</p>
                            <p>L'utilisateur ne pourra plus se connecter, mais ses données sont conservées. Un manager peut restaurer un utilisateur supprimé depuis sa fiche.</p>
                        </section></>}
                        {isManager && <>{(showLogistics || showRoutes || showBilling || showUsers) && <hr />}<section id="plans">
                            <h3>Abonnements</h3>
                            <p>Nemo propose trois formules d'abonnements adaptées à vos besoins. Votre abonnement détermine les modules accessibles pour votre entreprise.</p>
                            <table className="table table-hover align-middle mb-4 bg-white text-center">
                                <thead className="bg-light">
                                    <tr>
                                        <th className="text-start">Fonctionnalité</th>
                                        <th>Logistique</th>
                                        <th>Route</th>
                                        <th>Standard</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="text-start">Prix mensuel (H.T.)</td>
                                        <td><strong>140 €</strong></td>
                                        <td><strong>150 €</strong></td>
                                        <td><strong>225 €</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="text-start">Recherche de conteneurs</td>
                                        <td><Check /></td>
                                        <td><Cross /></td>
                                        <td><Check /></td>
                                    </tr>
                                    <tr>
                                        <td className="text-start">Création d'étiquettes d'expédition</td>
                                        <td><Check /></td>
                                        <td><Cross /></td>
                                        <td><Check /></td>
                                    </tr>
                                    <tr>
                                        <td className="text-start">Génération de rapports PDF</td>
                                        <td><Check /></td>
                                        <td><Cross /></td>
                                        <td><Check /></td>
                                    </tr>
                                    <tr>
                                        <td className="text-start">Suivi des routes en temps réel</td>
                                        <td><Cross /></td>
                                        <td><Check /></td>
                                        <td><Check /></td>
                                    </tr>
                                    <tr>
                                        <td className="text-start">Positions des livreurs sur carte</td>
                                        <td><Cross /></td>
                                        <td><Check /></td>
                                        <td><Check /></td>
                                    </tr>
                                    <tr>
                                        <td className="text-start">Détail des arrêts et problèmes</td>
                                        <td><Cross /></td>
                                        <td><Check /></td>
                                        <td><Check /></td>
                                    </tr>
                                    <tr>
                                        <td className="text-start">Trajets estimé et réel</td>
                                        <td><Cross /></td>
                                        <td><Check /></td>
                                        <td><Check /></td>
                                    </tr>
                                    <tr>
                                        <td className="text-start">Optimisation des tournées <small className="text-muted">(à venir)</small></td>
                                        <td><Cross /></td>
                                        <td><Check /></td>
                                        <td><Check /></td>
                                    </tr>
                                    <tr>
                                        <td className="text-start">Gestion des utilisateurs</td>
                                        <td><Check /></td>
                                        <td><Check /></td>
                                        <td><Check /></td>
                                    </tr>
                                    <tr>
                                        <td className="text-start">Facturation</td>
                                        <td><Check /></td>
                                        <td><Check /></td>
                                        <td><Check /></td>
                                    </tr>
                                </tbody>
                            </table>
                            <h5>Cycle de facturation</h5>
                            <ul>
                                <li>L'abonnement est mensuel. Une facture est générée au début de chaque période d'abonnement</li>
                                <li>Le paiement est dû avant la date limite de paiement de la facture</li>
                                <li>En cas de retard de paiement, une période de grâce est accordée</li>
                                <li>Passé ce délai, l'abonnement est suspendu et l'accès aux modules est bloqué</li>
                            </ul>
                        </section></>}
                    </div>
                    <div className="col-md-4">
                        <div id="scrollspy-collapsible" className="sticky-top">
                            <ul className="nav flex-column nav-pills menu-sidebar">
                                {showLogistics && <li className="nav-item">
                                    <a className="nav-link" href="#logistics">Logistique</a>
                                </li>}
                                {showRoutes && <li className="nav-item">
                                    <a className="nav-link" href="#routes">Route</a>
                                </li>}
                                {showBilling && <li className="nav-item">
                                    <a className="nav-link" href="#billings">Facturation</a>
                                </li>}
                                {showUsers && <li className="nav-item">
                                    <a className="nav-link" href="#users">Utilisateurs</a>
                                </li>}
                                {isManager && <li className="nav-item">
                                    <a className="nav-link" href="#plans">Abonnements</a>
                                </li>}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
